<template>
	<div class="m-comment" v-if="show">
		<h4 class="m-bt">
			<span class="u-tt">{{blockTitle}}</span>
		</h4>
		<comment-block :comments="comments"></comment-block>
	</div>
</template>

<script>
import CommentBlock from './comment/comment-block'
import 'styles/comment-normal.less'
export default {
	props: {
		comments: {
			type: Array,
			default: []
		},
		blockTitle: {
			type: String,
			default: '热门评论'
		}
	},
	components: {
		CommentBlock
	},
	computed: {
		show() {
			if(Jt.array.isEmpty(this.comments)) {
				return false;
			}
			return true;
		}
	}
}	
</script>


// WEBPACK FOOTER //
// comment-normal.vue?c08a800a